module.exports = __webpack_public_path__ + "static/media/btn-login-okta.bf379dcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/btn-login-okta.svg
// module id = 411
// module chunks = 1